import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoEstadoMultiselectComponent } from './novo-estado-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoEstadoMultiselectComponent],
  exports: [NovoEstadoMultiselectComponent]
})
export class NovoEstadoMultiselectModule {}
